import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { PickingRoute } from '../../../interfaces/Picking/Picking'
import { eTypePickingRoute } from '../../../enums/eTypePickingRoute'
import { StringLiteralLike } from 'typescript'

interface PickingRouteHeaderProps {
  pickingRoute: PickingRoute | undefined
  username?: string
  position?: string
  logo?: StringLiteralLike
  badge?: React.ReactNode
}

export const NewPickingRouteHeader: React.FC<PickingRouteHeaderProps> = ({
  pickingRoute,
  position,
  badge
}) => {
  const route: PickingRoute = pickingRoute || new PickingRoute()

  return (
    <Grid container direction='row' alignItems='center'>
      <Grid
        container
        item
        xs={12}
        direction='column'
        alignItems='center'
        alignContent='center'
        justifyContent='center'
        style={{ textAlign: 'center' }}
      >
        {badge && (
          <Box display='flex' justifyContent='center' mb={0.5}>
            {badge}
          </Box>
        )}
        <Typography variant='subtitle2' color='textSecondary'>
          Ruta:
          <span style={{ color: '#000000', fontSize: '1.5em' }}>
            {route.typePickingRouteId === eTypePickingRoute.RTV
              ? ` RTV${route.pickingRouteId}`
              : ` ${route.pickingRouteId}`}
          </span>
        </Typography>

        {position && <Typography variant='h6'>{position}</Typography>}

        <Typography variant='subtitle2' color='textSecondary'>
          Zona:
          <span style={{ color: '#000000' }}> {route.zoneName}</span>
        </Typography>
      </Grid>
    </Grid>
  )
}
